export default "__VITE_ASSET__BffOuXpY__"